import {
  shape, string, bool, number,
} from 'prop-types';

const treatments = shape({
  control: bool,
  testId: number,
  testType: string,
  treatmentId: string,
  treatmentName: string,
});

export default treatments;
